import React from 'react';
import NoSSR from 'react-no-ssr';
import MediaQuery from 'react-responsive';

import { trans, getResourcePath, useSoyuzData } from '@spotahome/soyuz/client';
import {
  Section,
  ThemeProvider,
  CookiesProvider,
  ToastContainer
} from '@spotahome/ui-library';

import LoginSignupModal from '@spotahome/landings-common/src/components/LoginSignupModal';
import SpottyCat from '@spotahome/landings-common/src/components/SpottyCat';
import Hero from '@spotahome/landings-common/src/components/Hero';
import HeaderContainer from '@spotahome/landings-common/src/components/HeaderContainer';
import FooterSimplified from '@spotahome/landings-common/src/components/FooterSimplified';
import AppBanner from '@spotahome/landings-common/src/components/AppBanner';

import { getAllCities } from '@spotahome/landings-common/src/graphql/queries/cities';

import {
  MQ_TABLET_MIN_WIDTH,
  MQ_MOBILE_MAX_WIDTH
} from '@spotahome/landings-common/src/constants';

// Styles
import '@spotahome/landings-common/src/scss/init.scss';

import AboutDifferent from './components/AboutDifferent';
import AboutStart from './components/AboutStart';
import AboutMission from './components/AboutMission';
import AboutBuild from './components/AboutBuild';

import AboutPress from './components/AboutPress';

const AboutUsContainer = () => {
  const { [AboutUsContainer.NAME]: requestedData } = useSoyuzData();
  const { cities, deviceType, initialCookie, userId } = requestedData;

  return (
    <CookiesProvider initialCookie={initialCookie}>
      <ThemeProvider flags={{ newButtons: true }}>
        <ToastContainer />
        <NoSSR>
          <MediaQuery minWidth={MQ_TABLET_MIN_WIDTH}>
            <Hero
              menu={<HeaderContainer tracking="ga-about-us" color="dark" />}
              title={trans('about-us.hero.title')}
              backgroundImage={`url(${getResourcePath(
                '/images/about-us/background-header.jpg'
              )})`}
            />
          </MediaQuery>
        </NoSSR>

        <NoSSR>
          <MediaQuery maxWidth={MQ_MOBILE_MAX_WIDTH}>
            <Hero
              menu={<HeaderContainer tracking="ga-about-us" color="dark" />}
              title={trans('about-us.hero.title')}
              backgroundImage={`url(${getResourcePath(
                '/images/about-us/mobile-header.jpg'
              )})`}
            />
          </MediaQuery>
        </NoSSR>

        <Section background="light">
          <AboutDifferent />
        </Section>

        <Section background="light">
          <AboutStart />
        </Section>

        <Section background="skin">
          <AboutMission />
        </Section>

        <AboutBuild />

        <Section background="light">
          <AboutPress />
        </Section>
        <LoginSignupModal isUserLogged={!!userId} />
        <FooterSimplified />
        <AppBanner deviceType={deviceType} />
        <SpottyCat
          cities={cities}
          isUserLogged={!!userId}
          deviceType={deviceType}
        />
      </ThemeProvider>
    </CookiesProvider>
  );
};

AboutUsContainer.NAME = 'AboutUsContainer';

AboutUsContainer.requestData = async (req, _, { graphqlClient }) => {
  try {
    const citiesResponse = await getAllCities(graphqlClient)(req.locale);
    const { cities } = citiesResponse.data;

    return {
      data: {
        cities,
        deviceType: req.device.type,
        initialCookie: req.headers.cookie
      }
    };
  } catch (err) {
    console.log(err);
  }

  return {
    data: {
      deviceType: req.device.type,
      initialCookie: req.headers.cookie
    }
  };
};

export default AboutUsContainer;
